export default __webpack_public_path__ + "static/media/logo1024x1024.7e3e48f7.png";